import { Text, Flex } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import QuestButton from 'views/VvsGotchi/components/QuestButton'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'

import { QuestsListProps } from './types'

const GameChallengesList: React.FC<QuestsListProps> = ({ quests }) => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column">
      {quests.map((q) => (
        <Flex p={3} key={q.symbol} flexDirection="column">
          <QuestButton quest={q} />
        </Flex>
      ))}

      <Flex flexDirection="column" justifyContent="center" alignItems="center" minHeight="200px">
        <PixelatedImage src="/images/vvsGotchi/controller.png" width="60px" mb={2} />
        <Text color="black" fontWeight="600">
          {t('More games coming soon...')}
        </Text>
        <Text color="black" fontWeight="600">
          {t('Stay tuned!')}
        </Text>
      </Flex>
    </Flex>
  )
}

export default GameChallengesList
